import { c as _c } from "react/compiler-runtime";
import { List, ListItem, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';
type BulletPointListItem = {
  label: string;
};
type BulletPointListProps<ItemType> = {
  items: ItemType[];
  renderItem: ({
    item
  }: {
    item: ItemType;
  }) => ReactNode;
  customContainerStyle?: SxProps<Theme>;
  customItemStyle?: SxProps<Theme>;
};
export function BulletPointList(t0) {
  const $ = _c(12);
  const {
    items,
    renderItem,
    customContainerStyle,
    customItemStyle
  } = t0;
  let t1;
  if ($[0] !== customContainerStyle) {
    t1 = {
      listStyleType: "disc",
      listStylePosition: "inside",
      ...customContainerStyle
    };
    $[0] = customContainerStyle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== customItemStyle || $[3] !== items || $[4] !== renderItem) {
    let t3;
    if ($[6] !== customItemStyle || $[7] !== renderItem) {
      t3 = item => <ListItem key={item.label} sx={{
        display: "list-item",
        padding: "4px 0",
        ...customItemStyle
      }}>{renderItem({
          item
        })}</ListItem>;
      $[6] = customItemStyle;
      $[7] = renderItem;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = items.map(t3);
    $[2] = customItemStyle;
    $[3] = items;
    $[4] = renderItem;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <List sx={t1}>{t2}</List>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}